module.exports = __webpack_public_path__ + "static/media/img-04.eeb95bc6.jpg";